module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_feusisberg-aed0f1ea3485febc142967ce289acd8c.png";